import { MatDialogRef } from '@angular/material';

export function defocusInitiatorAfterClosed(dialogRef: MatDialogRef<any>) {
  if (window.event && window.event.currentTarget) {
    const eventTarget: Element = window.event.currentTarget as Element;

    dialogRef.afterClosed().subscribe(() => {
      setTimeout(() => {
        if (eventTarget instanceof Element) {
          const initiator = eventTarget.classList.contains('cdk-program-focused')
            ? eventTarget
            : eventTarget.querySelector(`.cdk-program-focused`);

          if (initiator) {
            initiator.classList.remove('cdk-program-focused');
          }
        } else {
          console.warn('The initiator of the dialog could not be found');
        }
      }, 0);
    });
  }
}
